export const SEARCH_VISIT_REPORT = 'SEARCH_VISIT_REPORT';
export const SEARCH_VISIT_REPORT_START = 'SEARCH_VISIT_REPORT_START';
export const SEARCH_VISIT_REPORT_SUCCESS = 'SEARCH_VISIT_REPORT_SUCCESS';
export const SEARCH_VISIT_REPORT_ERROR = 'SEARCH_VISIT_REPORT_ERROR';

export const CLEAR_SEARCH_VISIT_REPORT = 'CLEAR_SEARCH_VISIT_REPORT';

// export const  UPDATE_VISIT_RADIOLOGIST = "[ADMIN] UPDATE_VISIT_RADIOLOGIST";
// export const  UPDATE_VISIT_RADIOLOGIST_START = "[ADMIN] UPDATE_VISIT_RADIOLOGIST_START";
// export const  UPDATE_VISIT_RADIOLOGIST_SUCCESS = "[ADMIN] UPDATE_VISIT_RADIOLOGIST_SUCCESS";
// export const  UPDATE_VISIT_RADIOLOGIST_ERROR = "[ADMIN] UPDATE_VISIT_RADIOLOGIST_ERROR";

export const RESET_VISIT_REPORT = 'RESET_VISIT_REPORT';
export const RESET_VISIT_REPORT_START = 'RESET_VISIT_REPORT_START';
export const RESET_VISIT_REPORT_SUCCESS = 'RESET_VISIT_REPORT_SUCCESS';
export const RESET_VISIT_REPORT_ERROR = 'RESET_VISIT_REPORT_ERROR';

export const searchVisitReport = (payload) => {
    return {
        type: SEARCH_VISIT_REPORT,
        payload
    };
}

export const clearSearchVisitReport = () => {
    return {
        type: CLEAR_SEARCH_VISIT_REPORT,
    };
}

// export const updateVisitRadiologist = (payload) => {
//     return {
//         type: UPDATE_VISIT_RADIOLOGIST,
//         payload
//     };
// }

export const resetVisitReport = (payload) => {
    return {
        type: RESET_VISIT_REPORT,
        payload
    };
}
